import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class ExpenseAllocation extends Base {
	constructor(props) {
		super(props);
		this.state = {
			confirmBeforeEsacpe: true,
			caller: props.Caller,
			controllerName: 'expense',
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			expenseItemId: this.isNull(props.ExpenseItemId) ? this.defaultGuid() : props.ExpenseItemId,
			data: null,
			loading: true,
			uiSettings: this.getUiSettings(),
			factors: []
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();

		this.getUiSettingConfigs({ formName: 'expense' });

		this.httpPost("api/v1/expense/getallocation", {
			id: this.state.id,
			expenseItemId: this.state.expenseItemId,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					//this.showErorrMessage(data.message);
					this.setState({
						data: data,
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();

		this.httpPost('api/v1/expense/saveallocation', {
			organizationId: this.state.data.global.company.id,
			expenseId: this.state.data.record.expenseId,
			expenseItemId: this.state.expenseItemId,
			total: this.state.data.record.total,
			sharedMethod: this.state.data.record.sharedMethod,
			items: this.state.data.record.items,
		}).then((data) => {
			if (data.status === -1) window.location.href = '/login';
			if (data.status === 1) {
				this.showSuccessMessage('تخصیص با موفقیت ذخیره شد');
				this.state.caller.getData();
				this.closeMe();
			} else {
				this.showErorrMessage(data.message);
				this.setState({
					loading: false,
				});
			}
		});
	}
	removeRow(id) {
		var temp = [];
		this.state.data.record.items
			.forEach((r) => {
				if (r.id != id) {
					temp.push(r);
				}
			});
		this.state.data.record.items = temp;
		this.allocateAmount();
	}
	allocateAmount() {
		var weightField = 'total';
		if (this.state.data.record.sharedMethod === 0) weightField = 'total';
		if (this.state.data.record.sharedMethod === 1) weightField = 'amount';
		if (this.state.data.record.sharedMethod === 2) weightField = 'amount';

		var totalAmount = this.state.data.record.total;

		if (this.state.data.record.sharedMethod === 4) {

			const equalShare = Math.floor(totalAmount / this.state.data.record.items.length);
			let allocatedSum = 0;

			this.state.data.record.items.forEach((row, index) => {
				let share;

				// آخرین آیتم باقیمانده را می‌گیرد
				if (index === this.state.data.record.items.length - 1) {
					share = totalAmount - allocatedSum;
				} else {
					share = equalShare;
					allocatedSum += share;
				}

				row.share = share;
			});

			this.setState({ data: this.state.data });
			return;
		}

		const totalWeight = this.state.data.record.items.reduce((sum, row) => sum + row[weightField], 0);

		let allocatedSum = 0;

		this.state.data.record.items.forEach((row, index) => {
			let share;

			// آخرين رديف مانده را مي‌گيرد تا جمع دقيقاً برابر شود
			if (index === this.state.data.record.items.length - 1) {
				share = totalAmount - allocatedSum;
			} else {
				share = Math.floor(totalAmount * row[weightField] / totalWeight);
				allocatedSum += share;
			}

			row.share = share;
		});
		this.setState({ data: this.state.data });
	}
	//override
	remove() {
		var id = this.state.id_to_remove;
		if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

		this.httpPost("api/v1/" + this.state.controllerName + "/removeallocation", {
			id,
			companyId: this.state.data.global.company.id,
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
					this.state.caller.getData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({ showConfirmRemove: false });
				}
			})
			.catch(err => {
				this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
			});
	}
	renderBody() {
		var trs = [];
		this.state.data.record.items.forEach((item, index) => {
			var tds = [];
			let refColumnIndex = 0;

			tds.push(<td>
				<span className="inGridRowNumber">{(index + 1)}</span>
			</td>);

			tds.push(<td>{item.factorNumber}</td>);
			tds.push(<td>{item.stuffName}</td>);
			tds.push(<td>{item.amount}</td>);
			tds.push(<td>{this.money(item.total)}</td>);
			tds.push(<td>{this.money(item.share)}</td>);

			tds.push(<td>
				<span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
			</td>);

			trs.push(<tr key={item.id}>
				{tds}
			</tr>);
		});

		return <tbody>{trs}</tbody>
	}
	searchFactors() {
		var factors = [];
		this.state.factors.forEach(f => factors.push(f.value));

		if (this.isEmpty(factors)) {
			this.showErorrMessage("لطفا حداقل یک فاکتور خرید مشخص نمایید");
			return;
		}

		this.state.data.record.items = [];

		this.httpPost('api/v1/expense/search/factor', {
			factors: factors,
		}).then((data) => {
			if (data.status === -1) window.location.href = '/login';
			if (data.status === 1) {
				this.state.loading = false;
				this.state.data.record.items = data.records;
				this.allocateAmount();
			} else {
				this.showErorrMessage(data.message);
				this.setState({
					loading: false,
				});
			}
		});

		this.setState({ data: this.state.data });
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">تخصیص هزینه</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">

								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">مجموع هزینه</label>
										{this.money(this.state.data.record.total)}
									</div>
									<div className="form-group">
										<label className="title1">مجمموع هزینه</label>
										<select onChange={(e) => {
											this.state.data.record.sharedMethod = parseInt(e.target.value);
											this.allocateAmount();
										}} defaultValue={this.state.data.record.sharedMethod} className="form-select">
											<option value="0">قيمتي</option>
											<option value="1">وزني</option>
											<option value="2">تعدادي</option>
											{/*<option value="3">دستي</option>*/}
											<option value="4">نسبت مساوی</option>
										</select>
									</div>
								</div>
								{this.state.data.record.allocated === false && <div className="col-sm-11">
									<label className="form-group">فاکتورهای خرید</label>
									<SelectAsync
										value={this.state.factors}
										isMulti={true}
										placeholder="انتخاب فاکتورهای خرید"
										noOptionsMessage={({ inputValue }) =>
											inputValue ? "نتیجه‌ای یافت نشد" : null
										}
										components={{
											DropdownIndicator: () => null,
											IndicatorSeparator: () => null,
										}}
										defaultOptions={[]}
										loadOptions={(inputValue, callback) => this.loadFactorsOptions(inputValue, callback, [1, 6, 10], 0)}
										onChange={e => this.setState({ factors: e })}
									/>
								</div>}
								{this.state.data.record.allocated === false && <div className="col-sm-1" style={{ display: "flex", justifyContent: "end", alignItems: "end" }}>
									<a onClick={(e) => this.searchFactors()} className="btn btn-warning">جمع آوری</a>
								</div>}

							</div>

							<div className="col-lg-12">
								<table className="table table-bordered acc_grid_row">
									<thead>
										<tr className="active">
											<td style={{ "width": "30px" }}>#</td>
											<td style={{ minWidth: "200px" }}>شماره فاکتور</td>
											<td>شرح کالا/خدمات</td>
											<td style={{ "width": "80px" }}>تعداد/مقدار<br /></td>
											<td style={{ "width": "80px" }}>مبلغ<br /><span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
											<td style={{ "width": "80px" }}>سهم<br /><span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
											<td style={{ "width": "35px" }}></td>
										</tr>
									</thead>
									{this.renderBody()}
								</table>
							</div>
						</div>
						<div className="modal-footer">
							{this.state.data.record.allocated === false && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره - صدور سند</button>}
							{this.state.data.record.allocated === true && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.expenseId)} >حذف</a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}